(function stateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('configViewService', [
            'restUrlBuilder', '$injector', 'config', 'authExtend', '$q', '$filter', function configViewService(restUrlBuilder, $injector, config, auth, $q, $filter) {

                var that = this;
                var views = undefined;
                var restUrlBuilder = restUrlBuilder('wf');

                auth.onIdentityChanged(function () {
                    that.init();
                });

                this.get = function get(ouId, name, appid) {
                    var params = {
                        OrganizationalUnitId: ouId,
                        name: name,
                        applicationId: appid
                    };

                    return restUrlBuilder.all('views').get({ params: params });
                };
               

                this.getById = function getById(id) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.load().then(function () {
                        var result = $filter('filter')(views, { id: id }, true);
                        if (result.length > 0)
                            defered.resolve(result[0]);
                        else {
                            defered.reject('Not View Found');
                        };
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                this.load = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (views) {
                        defered.resolve();
                    }
                    else {
                        this.get(undefined, undefined, config.appId()).then(function (result) {
                            views = result.value;
                            defered.resolve();

                        }, function (error) {
                            defered.reject(error);
                        });
                    }

                    return promise;
                };

                this.init = function() {
                    views = undefined;
                    this.load();
                };

                this.getByIdConfigView = function (id) {
                    return restUrlBuilder.one('views', id).get();
                };

                this.update = function (configView) {
                    return restUrlBuilder.all('views').put(configView);
                };

                this.clear = function () {
                    views = undefined;
                    return restUrlBuilder.all('views/clear').get();
                };
            }
        ]);
})();